import { ExchangeRateRepository } from '@domain/exchange-rate/repositories/exchange-rate.repository';
import { ExchangeRateRepositoryService } from '../repositories/exchange-rate.service';

export const ExchangeRateProvider = [
  {
    provide: ExchangeRateRepository,
    useClass: ExchangeRateRepositoryService,
  },
];
